module.exports = __webpack_public_path__ + "static/media/miscell_question.df7a43d1.mp3";